import { REGION } from '@env';
import { FormlyModule } from '@ngx-formly/core';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';

import { TranslationModule } from '@lib/translation';
import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';

import { SnMobilePhoneControl } from './components/control/mobile-phone.control';
import { SnMobilePhoneFormField } from './components/field-type/mobile-phone.field-type';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    ReactiveFormsModule,
    // Material
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatListModule,
    // Formly
    FormlyModule.forChild({
      types: [
        {
          name: 'mobile-phone',
          component: SnMobilePhoneFormField,
          wrappers: ['form-field'],
        },
      ],
    }),
    // Libs
    SnIconModule,
    SnButtonModule,
    TranslationModule,
  ],
  exports: [SnMobilePhoneControl],
  declarations: [SnMobilePhoneControl, SnMobilePhoneFormField],
  providers: [{ provide: REGION, useValue: REGION }],
})
export class SnFormMobilePhoneModule {}
